import { render, staticRenderFns } from "./CadastrarListaPresencaDialog.vue?vue&type=template&id=0fa68862&scoped=true"
import script from "./CadastrarListaPresencaDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarListaPresencaDialog.vue?vue&type=script&lang=js"
import style0 from "./CadastrarListaPresencaDialog.vue?vue&type=style&index=0&id=0fa68862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa68862",
  null
  
)

export default component.exports